export default function Guarantee() {
  return (
    <div className="grain-bg" data-testid="page-guarantee">
      <section className="border-b border-border bg-cream">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12 lg:py-28">
          <div className="section-label">Policies</div>
          <h1 className="mt-4 font-serif text-5xl tracking-tight sm:text-6xl">Health guarantee & policies.</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-stone">
            Transparency is part of how we do business. Below is exactly what to expect when you reserve, pick up, and bring home a rabbit from us.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 py-20 lg:px-12">
        <div className="space-y-12 text-base leading-relaxed text-foreground/85">
          <div>
            <h2 className="font-serif text-3xl">72-Hour health guarantee</h2>
            <p className="mt-4">Every rabbit is examined by us within 24 hours of pickup and again by an exotic vet before leaving. If a vet diagnoses a congenital or pre-existing condition within 72 hours of pickup, we will refund the purchase price or replace the rabbit from a future litter. (Receipt and signed vet statement required.)</p>
          </div>
          <div>
            <h2 className="font-serif text-3xl">Reservations & deposits</h2>
            <p className="mt-4">Reservations require a $50 refundable deposit, which is applied to the purchase price. Deposits are refundable up to 14 days before scheduled pickup. We hold reserved rabbits for up to 30 days past the wean date free of charge.</p>
          </div>
          <div>
            <h2 className="font-serif text-3xl">Local pickup, no shipping</h2>
            <p className="mt-4">We do not ship live rabbits. All pickups happen at our rabbitry in northeast Alabama, by appointment. Please bring a hard-sided carrier with a hay-lined bottom. We will spend 20–30 minutes reviewing your rabbit's habits, care card, and pedigree paperwork.</p>
          </div>
          <div>
            <h2 className="font-serif text-3xl">Alabama legal compliance</h2>
            <p className="mt-4">Lion's Mane (Lionhead) rabbits are a domestic rabbit breed (<em>Oryctolagus cuniculus domesticus</em>) and are <strong>legal to own, breed, and sell in the state of Alabama</strong>. We operate in good-faith compliance with the Alabama Department of Agriculture & Industries (ADAI) animal-husbandry guidelines, maintain herd health records, and welcome any reasonable questions from prospective owners.</p>
            <p className="mt-3">Outside-state buyers are responsible for confirming their own state's import requirements. Some states (e.g., FL, CA, HI) require additional health certificates or have breed restrictions — please check before reserving.</p>
          </div>
          <div>
            <h2 className="font-serif text-3xl">Spay / neuter & re-homing</h2>
            <p className="mt-4">If at any point you cannot keep your rabbit, please contact us first — we will always take a rabbit back, no questions asked, to rehome through our network.</p>
          </div>
          <div>
            <h2 className="font-serif text-3xl">What we do not guarantee</h2>
            <p className="mt-4">We cannot guarantee adult size, ear set, full mane retention, or show outcomes. Lion's Mane wool is genetically variable; some kits develop double manes that thin into single manes as they mature. Reproductive ability is also not guaranteed unless purchased as a "breeder-quality" rabbit with a signed addendum.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
